import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Address, User } from '../../types/user';
import { OrderModel, OrderType, PaymentMethodType } from './ordersSlice';
import api from '../../lib/axios';
import { CartItem } from './cartSlice';
import { PaymentMethod } from '../../types/paymentMethod';

export type deliveryFormDataType = {
    _id?: string;
    address?: Address;
    branch_id?: number;
    client_name?: string;
    phone_number?: string;
    cart?: CartItem[];
    future_date?: Date;
    notes?: string;
    delivery_price: number;
    order_type: OrderType;
    payment_method: PaymentMethodType;
    last_order_id?: string;
    payment_card?: PaymentMethod;
    payment_link?: string;
};

type InitialStateType = {
    deliveryForm: deliveryFormDataType;
    isOrderSubmitted: boolean;
    orderSubmissionError: string | null;
    lastOrder: OrderModel;
    isOrderSubmissionLoading: boolean;
};

const userString = localStorage.getItem('user');
const currentUser: User | null = userString ? JSON.parse(userString) : null;
const localStorageCart = localStorage.getItem('cart');
const initialState: InitialStateType = {
    deliveryForm: {
        client_name: `${currentUser?.first_name} ${currentUser?.last_name}` || ``,
        phone_number: localStorage.getItem('phoneNumber') || ``,
        cart: localStorageCart ? JSON.parse(localStorageCart) : [],
        notes: '',
        delivery_price: 0,
        order_type: 0,
        payment_method: 0,
    },
    isOrderSubmitted: false,
    orderSubmissionError: null,
    lastOrder: {
        _id: localStorage.getItem('LastOrderId') || undefined,
    },
    isOrderSubmissionLoading: false,
};

export type UpdateDeliveryFormDataType = Partial<deliveryFormDataType>;

const getUsernameFromLocalStorage = () => {
    const localstorageUserString = localStorage.getItem('user');
    const localstorageUser: User | null = localstorageUserString
        ? JSON.parse(localstorageUserString)
        : null;
    return localstorageUser
        ? `${localstorageUser.first_name} ${localstorageUser.last_name}`
        : 'WebOS-Guest';
};

const getPhoneNumber = () => {
    const phone = localStorage.getItem('phoneNumber');
    if (!phone || phone.trim() === '') {
        throw new Error('Missing phone number');
    }
    return phone;
};

export const createNewOrder = createAsyncThunk<OrderModel, OrderModel>(
    'deliveryForm/createNewOrder',
    async (DeliveryForm) => {
        console.log('CREATING NEW ORDER');
        const client_name = getUsernameFromLocalStorage();
        const phone_number = getPhoneNumber();

        const { data } = await api.post('order', {
            ...DeliveryForm,

            //Update the client name from the local storage.
            client_name: client_name,
            phone_number: phone_number,
            cart: JSON.parse(localStorage.getItem('cart') || ''),
        });
        return data.order;
    },
);

const deliveryFormSlice = createSlice({
    name: 'deliveryForm',
    initialState,
    reducers: {
        UpdateDeliveryFormData: (
            state,
            action: PayloadAction<Partial<UpdateDeliveryFormDataType>>,
        ) => {
            const deliveryFormDataUpdates = action.payload;
            state.deliveryForm = { ...state.deliveryForm, ...deliveryFormDataUpdates };
        },
    },
    extraReducers: (builder) => {
        builder.addCase(createNewOrder.pending, (state, action) => {
            state.orderSubmissionError = null;
            state.isOrderSubmissionLoading = true;
        });
        builder.addCase(createNewOrder.rejected, (state, action) => {
            console.log('ERROR!, action:', action);
            if (action.error.message) {
                state.orderSubmissionError = action.error.message;
            }
            state.isOrderSubmissionLoading = false;
        });
        builder.addCase(createNewOrder.fulfilled, (state, action) => {
            console.log('fulfilled, action:', action);
            state.lastOrder = action.payload;
            state.isOrderSubmitted = true;
            state.isOrderSubmissionLoading = false;
        });
    },
});

// Export actions
export const { UpdateDeliveryFormData } = deliveryFormSlice.actions;

// Export reducer
export default deliveryFormSlice.reducer;
